if (!customElements.get('video-custom-content-slider')) {
  customElements.define(
    'video-custom-content-slider',
    class LookbookCards extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.grid-and-slider',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.sliderInstance = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        // const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        const spaceBetween = 0;
        this.sliderOptions = {
          slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
          spaceBetween: spaceBetween,
          centeredSlides: true,
          breakpoints: {
            1024: {
              slidesPerView: this.dataset.items, // Number or auto
            },
          },
          loop: true,
          slideToClickedSlide: true,
          threshold: 2,
          on: {
            slideChange: () => this.handleSlideChange(),
            // init: () => this.handleSlideChange(), // Ensure video control on initialization
          },
        };

        if (this.dataset.sliderControls == '1') {
          const section = this.closest('#shopify-section-' + this.dataset.sectionId);

          this.sliderOptions.navigation = {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          };
        }

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }

// initSlider() {
//   if (typeof this.sliderInstance === 'object') return;

//   const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
//   const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

//   this.sliderOptions = {
//     slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
//     spaceBetween: spaceBetween,
//     centeredSlides: true,
//     loop: true,
//     threshold: 2,
//     on: {
//       slideChange: () => this.handleSlideChange(),
//       init: () => this.handleSlideChange(), // Ensure video control on initialization
//     },
//     breakpoints: {
//       1024: {
//         slidesPerView: this.dataset.items, // Number or auto
//       },
//     },
//   };

//   if (this.dataset.sliderControls == '1') {
//     const section = this.closest('#shopify-section-' + this.dataset.sectionId);

//     this.sliderOptions.navigation = {
//       nextEl: section.querySelector('.swiper-button-next'),
//       prevEl: section.querySelector('.swiper-button-prev'),
//     };
//   }

//   this.classList.add(this.classes.swiper);
//   this.sliderWrapper.classList.remove(this.classes.grid);
//   this.sliderWrapper.classList.add(this.classes.swiperWrapper);

//   this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
//   this.sliderInstance.init();
// }

handleSlideChange() {
  debugger;
  const slides = this.sliderWrapper.querySelectorAll('video-custom-content-slider .swiper-slide');
slides.forEach((slide) => {
    const videoElement = slide.querySelector('video-element');
    const playButton = slide.querySelector('button.media__poster');

    if (!videoElement || !playButton) return;

    // Check if the slide is the center slide
    // setTimeout(() => {
    // if (slide.classList.contains('swiper-slide-active')) {
    //   // Simulate play button click to start the video
    //   playButton.click();
    //   playButton.style.opacity = 0;
    //   playButton.style.visibility = 'hidden';
    // } else {
    //   // Stop video playback by interacting with the video tag inside the template
    //   const video = videoElement.querySelector('video');
    //   if (video) {
    //     video.pause();
    //     video.currentTime = 0; // Reset video to the beginning
    //   }
    //   playButton.style.opacity = 1;
    //   playButton.style.visibility = 'visible';
    // }
    // }, 500);
 setTimeout(() => {
  if (slide.classList.contains('swiper-slide-active')) {
    // Simulate play button click to start the video
    playButton.click();

    // Check if the video is paused, then play the video
    setTimeout(() => {
    const video = videoElement.querySelector('video');
    if (video && video.paused) {
      video.play();
    }
    }, 500);

    // Hide the play button
    playButton.style.opacity = 0;
    playButton.style.visibility = 'hidden';
  } else {
    // Stop video playback by interacting with the video tag inside the template
    const video = videoElement.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0; // Reset video to the beginning
    }

    // Show the play button
    playButton.style.opacity = 1;
    playButton.style.visibility = 'visible';
  }
}, 500);

  });

}


      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}



